const BLACKLIST_RE = /\+1\d{3}555\d{4}/;

export default function isMagicPhoneNumber(normalizedPhoneNumber: string) {
  return BLACKLIST_RE.test(normalizedPhoneNumber);
}
